import useIsMobile from '../../../hooks/useIsMobile'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'

const StoreBlockHero = ({ storeData }) => {
  const isMobile = useIsMobile()

  let backgroundImageUrl = storeData.data.background_images?.[0]?.url
  if (!backgroundImageUrl) {
    backgroundImageUrl = '/img/placeholder-store-bg.png'
  }

  return (
    <Row
      style={{ height: isMobile ? 450 : '60vh' }}
    >
      <Col
        xs={12}
        className={'h-100'}
      >
        <div className={'position-relative h-100 br-3 overflow-hidden'}>
          {backgroundImageUrl && (
            <Image
              src={backgroundImageUrl}
              alt={storeData.name + ' | Ivy Store'}
              className={'w-100 h-100 bg-light'}
              fluid
              style={{ objectFit: 'cover' }}
            />
          )}

          <div
            className={'position-absolute top-0 start-0 p-3 p-lg-4 px-lg-5 h-100 w-100'}
            style={{
              background: 'linear-gradient(to right, rgba(0,0,0,.7) 0%,  rgba(0,0,0,.6) 25%, rgba(0,0,0,0) 100%)'
            }}
          >
            <Row className={'h-100 w-100'}>
              <Col lg={6} xs={12}>
                <div className={'d-flex flex-column gap-3 gap-lg-4 text-white justify-content-center h-100'}>
                  <h1 className={'m-0 fs-2'}>
                    {storeData.data.hero_title}
                  </h1>

                  <div
                    className={'mb-2 fs-6'}
                    style={{
                      lineHeight: 1.6,
                      whiteSpace: 'break-spaces'
                    }}
                    // dangerouslySetInnerHTML={{ __html: ivystore.description?.replace(/\n/g, '<br />')}}
                  >
                    {storeData.data.hero_text}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default StoreBlockHero
